import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Form8991Service {

  constructor(private http: HttpClient) {}

  /**
   * Load countries for Schedule B.
   * Original action_code: kgdgoh
   */
  loadCountries(baseUrl: string): Observable<any> {
    return this.http.get<any>(`${baseUrl}/loadJsonObject?action_code=kgdgoh`, { withCredentials: true });
  }

  /**
   * Load Form 8991 details.
   * Original action_code: c799qw
   */
  loadFormData(
    baseUrl: string,
    rowData: any,
    partNo: string,
    scheduleName: string,
    filterParams: any = {}
  ): Observable<any> {
    const jcdKey = rowData?.JCD_KEY ?? filterParams?.jcd_key ?? 250;
    const params = new HttpParams()
      .set('action_code', 'c799qw')
      .set('tax_year', String(filterParams.tax_year ?? rowData?.TAX_YEAR ?? ''))
      .set('scenario', String(filterParams.scenario ?? rowData?.SCENARIO ?? ''))
      .set('jcd_key', String(jcdKey))
      .set('combination_key', String(rowData?.COMBINATION_KEY ?? ''))
      .set('schedule_name', scheduleName || '')
      .set('part_no', partNo || '')
      .set('FG_KEY', String(filterParams.filing_key ?? filterParams.fg_key ?? ''))
      .set('group_type', '');

    return this.http.get<any>(`${baseUrl}/loadJsonObject`, {
      params,
      withCredentials: true
    });
  }

  /**
   * Save Form 8991 data.
   * Original action_code: wc632k
   */
  saveFormData(
    baseUrl: string,
    finalData: any[],
    clobSettings: any[],
    partNo: string,
    scheduleName: string,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObjectAsFile?action_code=wc632k`;
    const jsonSettings = JSON.stringify(clobSettings);
    const jsonData = JSON.stringify(finalData);
    const blob = new Blob([jsonData], { type: 'text/plain' });

    const fd = new FormData();
    fd.append('file', blob);
    fd.append('process_name', 'form-8991-save');
    fd.append('json_settings', jsonSettings);
    fd.append('section_name', 'NA');
    fd.append('part_name', partNo || '');
    fd.append('schd_name', scheduleName || '');
    fd.append('form_name', '8991');
    fd.append('jcd_key', String(filterParams?.JCD_KEY ?? filterParams?.jcd_key ?? '250'));
    fd.append('scenario', String(filterParams?.scenario ?? ''));
    fd.append('tax_year', String(filterParams?.tax_year ?? ''));
    fd.append('sso_id', clobSettings?.[0]?.sso_id ?? '');
    fd.append('json_obj_param_name', 'json_data');

    return this.http.post<any>(url, fd, {
      headers: { 'Content-Type': undefined } as any,
      withCredentials: true
    });
  }
}
